<ng-container  *ngTemplateOutlet="template; context: {$implicit: context | async}"></ng-container>

